//
import { MaterialCommunityIcons, MaterialIcons } from '@expo/vector-icons';
import React from 'react';
import { StyleProp, StyleSheet, Text, View, ViewStyle } from 'react-native';
import { TXT_GG, TXT_M, TXT_P } from '../../constants';
import IconButton from './IconButton';

type Props = {
  quantidade: number;
  setQuantidade: (qnt: number) => void;
  minimo?: number;
  style?: StyleProp<ViewStyle>;
};

const MiniInputQuantidade: React.FC<Props> = (props) => {
  const { quantidade, setQuantidade, minimo, style } = props;

  const newQuantidadeMinima = minimo ? minimo : 0;

  return (
    <View style={[styles.container, style]}>
      <IconButton
        size={20}
        icon={<MaterialCommunityIcons name="minus" size={15} color={'#fff'} />}
        onPress={() => {
          if (quantidade - 1 >= newQuantidadeMinima) {
            setQuantidade(quantidade - 1);
          }
        }}
      />
      <View
        style={{
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <Text
          style={{
            fontSize: TXT_M,
            includeFontPadding: false,
            width: 28,
            textAlign: 'center'
            // fontWeight: '100'
          }}
        >
          {quantidade}
        </Text>
      </View>
      <IconButton
        size={20}
        icon={<MaterialIcons name="add" size={15} color={'#fff'} />}
        onPress={() => setQuantidade(quantidade + 1)}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    height: 30,
    alignSelf: 'center',
    alignItems: 'center',
    justifyContent: 'center'
  }
});

export default MiniInputQuantidade;
